import type { TableColumns } from '@ohpen/enso-ui';
import { ErcProfile, PenaltyTier } from '@pmp/api';
import { linkedToActiveTodayColumn, withSourceDecimals } from '@pmp/utils';
import { ErcProfileData } from './interfaces';

const ercDataColumns: TableColumns<ErcProfile> = [
  {
    title: 'pmp.erc.labels.ercProfileId',
    dataIndex: 'ercProfileId',
    key: 'ercProfileId',
    width: 260,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.ercProfileName',
    dataIndex: 'name',
    key: 'name',
    width: 230,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.penaltyValues',
    dataIndex: 'penaltyValues',
    key: 'penaltyValues',
    width: 230,
    options: {
      format: {
        type: 'percentageList',
      },
      filter: 'search',
    },
  },
];

const ercActionsColumn: TableColumns<ErcProfile>[number] = {
  title: 'enso.labels.actions',
  dataIndex: '',
  key: 'actions',
  width: 100,
  fixed: 'right',
};

export const ercColumns: TableColumns<ErcProfile> = [...ercDataColumns, ercActionsColumn];

export const ercListColumns: TableColumns<ErcProfile> = [
  ...ercDataColumns,
  linkedToActiveTodayColumn<ErcProfile>('pmp.erc.labels.linkedToActiveToday'),
  ercActionsColumn,
];

export const periodColumns: TableColumns<PenaltyTier> = [
  {
    title: 'pmp.erc.labels.order',
    dataIndex: 'order',
    key: 'order',
    width: 100,
    options: {
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.durationInMonths',
    dataIndex: 'durationInMonths',
    key: 'durationInMonths',
    width: 220,
    options: {
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    width: 160,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.ercPercentage',
    dataIndex: 'penaltyPercentage',
    key: 'penaltyPercentage',
    width: 160,
    options: {
      format: {
        type: 'percentage',
      },
      filter: 'number',
      sorter: true,
    },
  },
];

const ercProfilesFlatColumnsBase: TableColumns<ErcProfileData> = [
  {
    title: 'pmp.erc.labels.ercProfileId',
    dataIndex: 'ercProfileId',
    key: 'ercProfileId',
    width: 260,
    options: {},
  },
  {
    title: 'pmp.erc.labels.ercProfileName',
    dataIndex: 'name',
    key: 'name',
    width: 230,
    options: {},
  },
  {
    title: 'pmp.erc.labels.order',
    dataIndex: 'order',
    key: 'order',
    width: 100,
    options: {
      format: {
        type: 'number',
        decimalScale: 0,
      },
    },
  },
  {
    title: 'pmp.erc.labels.durationInMonths',
    dataIndex: 'durationInMonths',
    key: 'durationInMonths',
    width: 220,
    options: {
      format: {
        type: 'number',
        decimalScale: 0,
      },
    },
  },
  {
    title: 'pmp.erc.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    width: 160,
    options: {
      format: {
        type: 'date',
      },
    },
  },
  {
    title: 'pmp.erc.labels.ercPercentage',
    dataIndex: 'penaltyPercentage',
    key: 'penaltyPercentage',
    width: 160,
    options: {
      format: {
        type: 'percentage',
      },
    },
  },
];

export const ercProfilesFlatColumns = withSourceDecimals([periodColumns], ercProfilesFlatColumnsBase);
